<template>
  <div class="rectification-boards-card-item">
    <div class="top-wrap">
      <div class="card-header">
        <el-tooltip :popper-class="showTips" :content="rectificData.unitName" placement="top-start">
          <span class="header-contex" :id="id">{{ rectificData.unitName }}</span>
        </el-tooltip>
      </div>
      <div class="card-data">
        <div class="card-number">
          <span style="font-size: 30px;">{{ rectificData.rectificationCompletedCount }}</span>
          <span>/</span>
          <span>{{ rectificData.negativeReviewCount }}</span>
        </div>
        <span class="card-notice">已整改 / 文档差评</span>
        <i class="card-notice-done" v-show="rectificData.negativeReviewCount === rectificData.rectificationCompletedCount"></i>
      </div>
    </div>
    <div class="card-info">{{ rectificData.deptName }}-{{rectificData.responsiblePerson}}</div>
    <div class="card-action" @click="getDetails()">
      <span>详情</span>
      <span class="action-icon"></span>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    rectificData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      id: `header-contex${Math.random()}`,
      showTips: 'hidden-rectification-card-tips',
    }
  },
  mounted() {
    this.getCellspopOver()
  },
  methods: {
    getCellspopOver() {
      const cell = document.getElementById(this.id)
      if (cell.scrollHeight > 66) {
        this.showTips = ''
      } else {
        this.showTips = 'hidden-rectification-card-tips'
      }
    },
    getDetails() {
      const { unitName, unitCode } = this.rectificData
      this.$emit('clickBoard', unitName, unitCode)
    }
  },
}
</script>

<style lang="scss">
.hidden-rectification-card-tips {
  display: none;
}
</style>
<style lang="scss" scoped>
@import "~@/assets/styles/mixin.scss";
.rectification-boards-card-item {
  width: 227px;
  height: 126px;
  background-color: #F9F9F9;
  box-sizing: border-box;
  padding: 12px;
  padding-right: 0;
  position: relative;
  .top-wrap {
    height: 70px;
    display: grid;
    grid-row: 1;
    grid-template-columns: 70px 145px;

    .card-header {
      width: 70px;
      height: 66px;
      padding: 4px;
      font-size: 13px;
      line-height: 15px;
      color: #3C6EF0;
      display: grid;
      @include font-family-jd;
      border-radius: 6px;
      justify-content: center;
      align-items: center;
      text-align: center;
      background: rgba(60,110,240,0.1);
      box-sizing: border-box;
      overflow: hidden;
      cursor: pointer;
      .header-contex {
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
    }
    .card-data {
      padding-left: 12px;
      padding-top: 8px;
      height: 66px;
      .card-number {
        @include font-family-jd-ht;
        color: #FC3737;
        font-size: 12px;
        font-weight: 500;
        line-height: 20px;
        height: 20px;
      }
      .card-notice {
        font-size: 12px;
        line-height: 32px;
        @include font-family;
        font-weight: 500;
        color: rgba(82,87,101,0.99);
      }
      .card-notice-done {
        width: 18px;
        height: 18px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 8px;
        background-size: cover;
        background-image: url("~@/assets/front/lui-icon-arrow-cycle-down-solid.png");
      }
    }
  }
  .card-info {
    width: 151px;
    line-height: 16px;
    font-size: 10px;
    font-family: "PingFang SC";
    font-weight: normal;
    color: #868D9F;
  }
  .card-action {
    font-weight: 500;
    font-size: 14px;
    color: #868D9F;
    bottom: 12px;
    right: 12px;
    position: absolute;
    cursor: pointer;
    .action-icon {
      width: 14px;
      height: 14px;
      display: inline-block;
      vertical-align: middle;
      margin-left: 4px;
      margin-top: -2px;
      background-image: url("~@/assets/front/lui-icon-arrow-cycle-right-solid.png");
      background-size: cover;
    }
    &:hover {
      color: #3C6EF0;
      .action-icon {
        background-image: url("~@/assets/front/lui-icon-arrow-cycle-right-solid-done.png");
      }
    }
  }
}
</style>
